import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';
import { idLikeSchema } from '@zaoblako/shared/modules/serde/schemas/id-like.schema';

import * as yup from 'yup';

/** BRS task order create and update form - DTO signature */
export interface TaskOrderFormInterface {
  /** Unique identifier. Cannot be changed */
  id?: number;
  /** Payment amount in roubles */
  amount?: number;
  /** Task order subject */
  subject?: string;
  /** Payment date */
  date?: Date;
}

/** BRS task order create and update form - DTO schema */
export const TaskOrderFormDto = SerdeDtoClass.create<TaskOrderFormInterface>(TaskDtoKeysEnum.TASK_ORDER_FORM_DTO, {
  id: {
    optional: true,
    label: 'Номер заявки',
    serializer: idLikeSchema,
  },
  amount: {
    optional: true,
    label: 'Сумма платежа',
    serializer: yup.number(),
  },
  subject: {
    optional: true,
    label: 'Назначение платежа',
    serializer: yup.string(),
  },
  date: {
    optional: true,
    label: 'Дата платежа',
    serializer: yup.date(),
  },
});
